import mergeTw from 'features/common/utils/mergeClasses'
import React from 'react'
import Spinner from '../Spinner'

type View = 'primary' | 'alt'
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string
    isLoading?: boolean
    view?: View
}

const classNameByView: Record<View, string> = {
    primary: `text-white bg-yellow-40
        hover:bg-yellow-10
        active:bg-yellow-10
    `,
    alt: `text-yellow-40 bg-white border-2 border-yellow-40 rounded-[1.25rem]
        hover:text-yellow-10
        hover:border-yellow-10
        active:border-yellow-10
        active:text-yellow-10
    `,
}

const Button = ({
    view = 'primary',
    className,
    isLoading,
    ...props
}: ButtonProps) => {
    const baseClassName = `flex-1 text-xl font-bold rounded-3xl
        active:shadow-y-inset
        disabled:opacity-50
        flex items-center justify-center
    `

    const buttonClasseName = mergeTw(
        baseClassName,
        classNameByView[view],
        className,
    )

    return (
        <button className={buttonClasseName} {...props}>
            {props.children}
            {isLoading && (
                <div className="w-0 basis-0 overflow-visible">
                    <div className="w-9 pl-1">
                        <Spinner />
                    </div>
                </div>
            )}
        </button>
    )
}

export default Button
